import React from 'react'

const AboutPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-white">
      <div className="max-w-4xl mx-auto py-16 px-4">
        <h1 className="text-4xl font-bold text-gray-900 mb-8">About MotoManual.ai</h1>
        <p className="text-lg text-gray-600">
          MotoManual.ai is an AI-powered service assistant specifically designed for 
          Indian Chief and Scout motorcycle maintenance and service procedures.
        </p>
      </div>
    </div>
  )
}

export default AboutPage
